import EarlyAccess from './EarlyAccess.vue';

export default EarlyAccess;